export default __webpack_public_path__ + "static/media/logo_Enershare.f9f82815.svg";